import "./styles.css";
import { Navigate, Route, Routes } from "react-router";
import About from "./About";
import Home from "./Home";

import Courses from "./Home/Courses";


import HomeNavigation from "./Navigation";
import Portfolio from "./Home/protfolio";
import Projects from "./Home/Projects";
import Piano from "./Home/Piano";
import Volunteer from "./Home/Volunteer";
import Travel from "./Home/Travel";
import Fitness from "./Home/Fitness";



export default function Rayan() {

    return (
        <div >
        <HomeNavigation />
        <Routes>
            <Route path="/" element={<Navigate to="Home" />} />
            <Route path="Home/*" element={<Home />} />
            <Route path="Portfolio/*" element={<Portfolio/>} />
            <Route path="About/*" element={<About />} />
            <Route path="Home/projects/:pid/*" element={<Projects/>} />
            <Route path="Courses/*" element={<Courses/>} /> 
            <Route path="Piano" element={<Piano/>}/>
            <Route path="Volunteer" element={<Volunteer/>}/>
            <Route path="Travel" element={<Travel/>}/>
            <Route path="Fitness" element={<Fitness/>}/>
            </Routes>


        </div>
    )
}